import React from "react";
import { useCanViewCheckouts } from "checkouts/hooks/useCanViewCheckouts";
import { EmptyContent } from "core/components/EmptyContent";
import { Layout } from "core/components/Layout";
import { SupervisorsHeader } from "supervisors/components/SupervisorsHeader";
import { SupervisorsList } from "supervisors/components/SupervisorsList";

export const SupervisorsViewContent = () => {
  return (
    <Layout
      pageSubheader={<SupervisorsHeader />}
      pageTitle="Cleaning Supervisors"
    >
      <SupervisorsList />
    </Layout>
  );
};

export const SupervisorsView = () => {
  const { loading, canViewCheckouts } = useCanViewCheckouts();
  if (!canViewCheckouts) {
    return (
      <Layout pageSubheader="" pageTitle="Cleaning Supervisors">
        {!loading && (
          <EmptyContent>
            <p>
              Your account is not currently able to view Checkouts / Cleaning
              Supervisors
              <br />
              This feature is currently in early access.
            </p>
          </EmptyContent>
        )}
      </Layout>
    );
  }

  return <SupervisorsViewContent />;
};
